<div class="modal-header">
    <h5 class="modal-title">{{location.locationId ? 'New' : 'Edit'}} Storage Location</h5>
    <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
</div>
<dirty-tracking [forms]="[locationForm]"></dirty-tracking>
<form novalidate #locationForm="ngForm" [ngClass]="{'was-validated': submitAttempt}">
    <div class="modal-body">
        <div class="row gx-3">
            <div class="col-md mb-3">
                <label for="locationName" class="form-label">Name<sup class="text-danger">*</sup></label>
                <input type="text" focus-me class="form-control form-control-lg" id="locationName" name="locationName" placeholder="Name" required [(ngModel)]="location.locationName">
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div>
            <div class="col-md mb-3">
                <label for="description" class="form-label">Description</label>
                <input type="text" class="form-control form-control-lg" id="description" name="description" placeholder="Description" [(ngModel)]="location.description">
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-black btn-round btn-lg" (click)="dismiss()"><i class="far fa-times"></i> Cancel</button>
        <button type="submit" class="btn btn-secondary btn-round btn-lg" (click)="save()"><i class="far fa-check"></i> Save</button>
    </div>
</form>